var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSignupModalCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.79163,
    y: 6.79199,
    width: 60.4167,
    height: 60.4167,
    rx: 30.2083,
    fill: "#6E42FF",
    stroke: "#6728FF",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7455 51.5895C32.9125 51.5895 32.2099 51.2483 31.6378 50.5658L24.2908 41.5928C24.0499 41.3117 23.8793 41.0458 23.7789 40.7948C23.6785 40.5339 23.6283 40.2579 23.6283 39.9668C23.6283 39.3445 23.8391 38.8276 24.2607 38.4161C24.6822 38.0046 25.2142 37.7988 25.8565 37.7988C26.5792 37.7988 27.1814 38.0949 27.6632 38.6871L33.6853 46.2148L45.4887 27.5461C45.7597 27.1246 46.0457 26.8285 46.3468 26.6579C46.6479 26.4772 47.0193 26.3869 47.4609 26.3869C48.1033 26.3869 48.6302 26.5926 49.0417 27.0041C49.4533 27.4056 49.659 27.9175 49.659 28.5398C49.659 28.7706 49.6189 29.0165 49.5386 29.2775C49.4583 29.5284 49.3328 29.7894 49.1622 30.0604L35.8683 50.4905C35.3765 51.2232 34.6689 51.5895 33.7455 51.5895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignupModalCheckIcon);
export default __webpack_public_path__ + "static/media/ic_signup_modal_check_icon.8e7a1a28aed4ad3949e66b5d57393e90.svg";
export { ForwardRef as ReactComponent };